// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
        apiKey: 'AIzaSyD52hRo-29J-6-kfdMK5xL8SPUdPy2UqYc',
        authDomain: 'prodej-front.firebaseapp.com',
        databaseURL: 'https://prodej-front-default-rtdb.firebaseio.com',
        projectId: 'prodej-front',
        storageBucket: 'prodej-front.appspot.com',
        messagingSenderId: '896578275833',
        appId: '1:896578275833:web:6c7ff6cd1c2486d9141528',
        measurementId: 'G-Z127D72VG0'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
